module.exports = function () {
	$('.C2-search-results__pagination__trigger').click(function (e) {
		e.preventDefault();

		if (!$(this).attr('disabled')) {
			var targetPage = $(this).data('page');
			window.page = targetPage;

			Innophos.Pages.ProductSearchPage.InsertResults();
		}
	});

	var adjustSearchTopPosition = function () {
		var $searchResultsTop = $('.C2-search-results__inner__top');
		var searchResultsStickyClass = 'C2-search-results__inner__top--sticky';
		var $searchResultsTopParent = $searchResultsTop.parent();
		var $searchResultsTopSibling = $searchResultsTop.nextAll('.C2-search-results__result').first();
		
		if ($('.product-search-bar__content-outer').hasClass('product-search-bar__content-outer--fixed'))
		{
			$searchResultsTop.addClass(searchResultsStickyClass);
			$searchResultsTop.css({ 'width': $searchResultsTopParent.width() + 'px' });
			$searchResultsTopSibling.css({
				'padding-top': ($searchResultsTop.height() + 32) + 'px'
			});
		}
		else {
			$searchResultsTop.removeClass(searchResultsStickyClass);
			$searchResultsTop.css({ 'width': '' });
			$searchResultsTopSibling.css({
				'padding-top': '32px'
			});
		}
	};

	if ($('.C2-search-results').length) {
		$(window).scroll(function () {
			requestAnimationFrame(adjustSearchTopPosition);
		});

		$(window).resize(function () {
			requestAnimationFrame(adjustSearchTopPosition);
		});

		requestAnimationFrame(adjustSearchTopPosition);
	}
};
